<template>
    <div class="content-inner">
        <x-panel margin>
            <div slot="title">Login / Logout Log</div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-select
                    v-model="listFilters.user"
                    class="mr-2 input-belt"
                    clearable
                    @change="handleFilter(true)"
                    @clear="handleFilter(true)"
                    :loading="loading"
                    reserve-keyword
                    placeholder="Filter By Users"
                >
                    <el-option-group label="Brokers">
                        <el-option
                            v-for="item in userFilter"
                            :key="item.id"
                            :label="`${item.first_name} ${item.last_name}`"
                            :value="item.id"
                        ></el-option>
                    </el-option-group>
                </el-select>
                <el-input
                    v-model="listFilters.search"
                    placeholder="Search IP or Location (City, State, Postcode)... "
                    clearable
                    class="filter-item mr-2"
                    @keyup.enter.native="handleFilter(true)"
                    @clear="handleFilter(true)"
                />
                <el-button v-waves type="primary" icon="el-icon-search" @click="handleFilter(true)">Search</el-button>
            </div>
        </x-panel>
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="loading"
            fit
            ref="filterTable"
            row-key="id"
            border
            :row-class-name="tableRowClassName"
            default-expand-all
        >
            <el-table-column prop="ip_address" label="IP Address"></el-table-column>
            <el-table-column prop="authenticatable" label="User">
                <template slot-scope="scope">
                    <a @click.stop v-if="scope.row.authenticatable.full_name" target="_blank" :href="scope.row.authenticatable.search_url">
                         {{ scope.row.authenticatable.full_name }}
                    </a>
                </template>
            </el-table-column>
            <el-table-column prop="login_at" align="center" label="Login"  :formatter="formatDate"></el-table-column>
            <el-table-column prop="logout_at" align="center" label="Logout"  :formatter="formatDate"></el-table-column>
            <el-table-column header-align="center" label="State">
                <template slot-scope="scope">
                    {{ _.get(scope.row.location, "state") }}
                </template>
            </el-table-column>
            <el-table-column header-align="center" label="City / Town">
                <template slot-scope="scope">
                    {{ _.get(scope.row.location, "city") }}
                </template>
            </el-table-column>
            <el-table-column header-align="center" label="Postcode">
                <template slot-scope="scope">
                    {{ _.get(scope.row.location, "postal_code") }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="Status">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.login_successful ? 'success' : 'danger'">
                        {{ scope.row.login_successful ? "Success" : "Failed" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Action" width="110" align="center">
                <template slot-scope="scope">
                    <el-dropdown class="w-100">
                        <el-button style="color: green" size="small" @click="handleActionButtonClick">
                            Action
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleBlacklist(scope.row)" v-if="!_.get(scope.row, 'blacklisted')">
                                <span>Blacklist IP</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="collection.total > 0"
            :total="collection.total"
            :page.sync="collection.current_page"
            :limit.sync="collection.per_page"
            @pagination="getCollection"
        />
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import Pagination from '@shared/components/pagination'
    import ipInput from './IpInput'

    export default {
        name: 'AuthenticationLog',
        components: { Pagination, ipInput },
        props: {
        },
        data() {
            return {
                collection: {},
                search: '',
                loading: true,
                usersInitial: [],
                listFilters: {
                    search: "",
                    ip: "",
                    user: ""
                },
                listLimit: 10,
                selected: {}
            }
        },
    computed: {
            ...mapGetters({
				user: "user/user",
			}),
            userFilter: function () {
                // exclude deleted, inactive and admins
                let userList = this.usersInitial.filter(
                    (item) => !item.deleted_at && item.active && item.roles.find((role) => role.name == "broker")
                )

                return userList
            },
        },
        watch: {
        },
    mounted() {
        this.getUsers();
        this.$tenant.get(`/api/settings/auth-logs`)
            .then((res) => {
                this.setData(res, 'collection')
            }).catch(err => {
                err.output()
            })

        },
        updated() {
        },
        activated() {
        },
        methods: {
            setData(res, model) {
                this.$set(this.$data, model, res.data.collection)
                this.loading = false;
                this.$bar.finish()
            },
            clearFilter() {
                this.$refs.filterTable.clearFilter();
            },
            handleFilter(loading = false) {
                this.loading = loading;
                let collection = this.collection;
                let event = {
                    page: 1,
                    limit: collection.per_page
                }
                this.getCollection(event);
            },
            tableRowClassName({ row }) {
                if (_.get(row, 'blacklisted') == true) {
                    return 'danger-row';
                }
                return '';
            },
            handleBlacklist(row) {
                this.$tenant.post(`/api/settings/ip-blacklist/create`,
                    {
                        ip: _.get(row, 'ip_address'),
                        action: 0,
                        expiration: '',
                        description: 'blacklisted via Authentication Log'
                    })
                    .then((res) => {
                        this.handleFilter()
                    }).catch(err => {
                        err.output()
                    })
            },
            getCollection(event) {
                this.$bar.start()
                this.$tenant.get(`/api/settings/auth-logs?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
                    .then(res => {
                        this.$set(this.$data, 'collection', res.data.collection)
                        this.loading = false;
                        this.$bar.finish()
                    }).catch(err => {
                        err.output()
                    })
            },
            async getUsers() {
                try {
                    let res = await this.$tenant.get(`/api/v2/referrers`)
                    this.usersInitial = res.data
                } catch (err) {
                    console.error(err)
                }
            },
            handleActionButtonClick(e) {
                e.stopPropagation()
            },
            formatDate(row) {
				let login = this.$moment.utc(row.login_at).tz(_.get(this.user, 'timezone', 'Australia/Brisbane'))
				let logout = this.$moment.utc(row.logout_at).tz(_.get(this.user, 'timezone', 'Australia/Brisbane'))
				if (login) {
					return this.$moment.utc(row.login_at).tz(_.get(this.user, 'timezone', 'Australia/Brisbane')).format("ddd DD/MM/YY LT")
                }
                if (logout) {
					return this.$moment.utc(row.logout_at).tz(_.get(this.user, 'timezone', 'Australia/Brisbane')).format("ddd DD/MM/YY LT")
				}
			},
        }
    }
</script>

<style lang="scss">
    // @import '@assets/sass/backend/_core-variables.scss';
    .logo-box {
        position: relative;
        min-height: 120px;

        .action {
            position: absolute;
            right: 10px;
            bottom: 10px;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            background: #bababa;
            text-align: center;
            font-size: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .team-manage {
        h4 {
            margin-bottom: 1rem !important;
        }
    }

    .danger-row {
        background: rgba(#f00, 0.2) !important;
    }
</style>
